<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("devices.survey.title") }}</h5>
    <div class="notification is-info is-light">
      {{ $t("devices.survey.message") }}
    </div>

    <div class="control">
      <table class="table is-fullwidth">
        <tr>
          <td>
            <p>{{ $t("devices.survey.q1_is_people") }}</p>
            <p style="margin-left: 1rem;">
              <label class="radio">
                <input
                  type="radio"
                  name="survey1"
                  id="yes"
                  v-model="survey1"
                  value="true"
                />
                {{ $t("devices.survey.ans1_yes") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey1"
                  id="no"
                  v-model="survey1"
                  value="false"
                />
                {{ $t("devices.survey.ans1_no") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey1"
                  id="unknown"
                  v-model="survey1"
                  value="2"
                  checked
                />
                {{ $t("devices.survey.unknown") }} </label
              ><br />
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>{{ $t("devices.survey.q2_is_hotbg") }}</p>
            <p style="margin-left: 1rem;">
              <label class="radio">
                <input
                  type="radio"
                  name="survey2"
                  id="yes"
                  v-model="survey2"
                  value="true"
                />
                {{ $t("devices.survey.yes") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey2"
                  id="no"
                  v-model="survey2"
                  value="false"
                />
                {{ $t("devices.survey.no") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey2"
                  id="unknown"
                  v-model="survey2"
                  value="2"
                  checked
                />
                {{ $t("devices.survey.unknown") }} </label
              ><br />
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>{{ $t("devices.survey.q3_range") }}</p>
            <p style="margin-left: 1rem;">
              <label class="radio">
                <input
                  type="radio"
                  name="survey3"
                  id="und1m"
                  v-model="survey3"
                  value="<1m"
                />
                {{ $t("devices.survey.und1m") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey3"
                  id="1mto2m"
                  v-model="survey3"
                  value="1m-2m"
                />
                {{ $t("devices.survey.ans3_1to2m") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey3"
                  id="2mto4m"
                  v-model="survey3"
                  value="2m-4m"
                />
                {{ $t("devices.survey.ans3_2to4m") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey3"
                  id="ovr4m"
                  v-model="survey3"
                  value=">4m"
                />
                {{ $t("devices.survey.ovr4m") }} </label
              ><br />
              <label class="radio">
                <input
                  type="radio"
                  name="survey3"
                  id="unknown"
                  v-model="survey3"
                  value="2"
                  checked
                />
                {{ $t("devices.survey.unknown") }} </label
              ><br />
            </p>
          </td>
        </tr>
      </table>
    </div>

    <div class="field mt-4">
      <button
        class="button is-primary"
        @click="onSubmit"
        v-bind:class="{ 'is-loading': isLoad }"
      >
        {{ $t("Create") }}
      </button>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import imsr from "@/imsr-api";
import { ref } from "@vue/reactivity";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const isLoad = ref(false);
    const deviceId = ref(route.params.deviceId);
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: "Device Config",
        path: {
          name: "devicesList",
          params: { projectId: route.params.projectId },
        },
      },
      {
        title: route.params.deviceId,
        path: {
          name: "devicesView",
          params: {
            projectId: route.params.projectId,
            deviceId: route.params.deviceId,
          },
        },
      },
      { title: "Survey", path: "#", isActive: true },
    ]);

    const survey1 = ref("2");
    const survey2 = ref("2");
    const survey3 = ref("2");

    const onSubmit = async () => {
      try {
        isLoad.value = true;
        const params = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
          deviceId: route.params.deviceId,
          q1People: survey1.value,
          q2Hotbg: survey2.value,
          q3Range: survey3.value,
        };

        await imsr.imsrPutApi("/devices/enquete", params);
        isLoad.value = false;
        router.push({
          name: "devicesView",
          params: {
            projectId: route.params.projectId,
            deviceId: route.params.deviceId,
          },
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };

    return {
      isLoad,
      breadcrumb,
      deviceId,
      onSubmit,
      survey1,
      survey2,
      survey3,
    };
  },
};
</script>
